import React, { useEffect, useState, useContext } from "react";
import useMediaQuery from '@mui/material/useMediaQuery';

export const InteriorArea = (props) => {
    const [sectionMarginTop, setSectionMarginTop] = useState('');
    const notMobile = useMediaQuery('(min-width:992px)');

    useEffect(() => {
        if (notMobile) {
        let rowPaddingInterior = document.querySelector('.box-interiorarea').getBoundingClientRect().height;
        setSectionMarginTop((rowPaddingInterior + 60) + "px");
        }
    }, [notMobile]);


    return (
        <>
            {props.cultureCode === "en-us" &&
                <div className="container-fluid bkg-interiorarea" id="Interiors">
                    <div className="container pb-5">
                        <div className="row">
                            <div className="col text-center">
                                <h3 className="dots-gallery"></h3>
                            </div>
                        </div>
                    </div>
                    <div className="header-section text-white text-center py-5"><h1 className="h1">Interiors</h1></div>
                    <div className="container py-5">
                        <div className="row justify-content-center">
                            <div className="col-md-10 text-center pt-5" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3 text-white">Elegance meets functionality</h2>
                                <img src="images/Infynito80/maindeck/main.jpg" alt="" className="w-100" />
                            </div>
                            <div className="col-lg-6 position-relative order-2 order-lg-1" data-aos="fade-up" data-aos-duration="1500">
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-galley pin-animation" />
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-saloon pin-animation" />
                                <img src="images/Infynito80/main-deck.png" alt="" className="main-deck-interiorarea w-100" />
                            </div>
                            <div className="col-lg-6 position-relative order-1 order-lg-2">
                                <div className="box box-interiorarea">
                                    <h3 className="mb-3">Interior area</h3>
                                    <p>The galley seamlessly connects to the All-Season Terrace through a hi-lo glass wall, while the main salon features elegant decor and free standing seating, with ceiling TV up to 55". Convert the dining area into a country kitchen with bar counter and stools, creating the perfect open-concept space for living and entertaining.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row pb-lg-5" style={{ marginTop: sectionMarginTop }}></div>
                    </div>
                </div>
            }
            {props.cultureCode === "it-it" &&
                <div className="container-fluid bkg-interiorarea" id="Interiors">
                    <div className="container pb-5">
                        <div className="row">
                            <div className="col text-center">
                                <h3 className="dots-gallery"></h3>
                            </div>
                        </div>
                    </div>
                    <div className="header-section text-white text-center py-5"><h1 className="h1">Interni</h1></div>
                    <div className="container py-5">
                        <div className="row justify-content-center">
                            <div className="col-md-10 text-center pt-5" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3 text-white">L'eleganza incontra la funzionalità</h2>
                                <img src="images/Infynito80/maindeck/main.jpg" alt="" className="w-100" />
                            </div>
                            <div className="col-lg-6 position-relative order-2 order-lg-1" data-aos="fade-up" data-aos-duration="1500">
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-galley pin-animation" />
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-saloon pin-animation" />
                                <img src="images/Infynito80/main-deck.png" alt="" className="main-deck-interiorarea w-100" />
                            </div>
                            <div className="col-lg-6 position-relative order-1 order-lg-2">
                                <div className="box box-interiorarea">
                                    <h3 className="mb-3">Interni</h3>
                                    <p>La cucina, con viste panoramiche, è collegata alla All-Season Terrace, mentre il salone principale presenta decorazioni eleganti e divani e zona pranzo free-standing, completato da una TV montata a soffitto fino a 55 pollici. Trasforma l'area pranzo in una cucina a vista con bancone e sgabelli, per creare il perfetto open space tutto da vivere. </p>
                                </div>
                            </div>
                        </div>
                        <div className="row pb-lg-5" style={{ marginTop: sectionMarginTop }}></div>
                    </div>
                </div>
            }

        </>
    );




};

export default InteriorArea;